<template>
    <span v-if="isLargeScreen" :class="[faIconDragAndDropClassName]" class="text-secondary">
        <font-awesome-icon :icon="['fas', 'grip-vertical']"></font-awesome-icon>
    </span>
</template>

<script>
import { isLargeScreen } from '../../../utils/screens';
import { faIconDragAndDropClassName } from './constants';

export default {
    name: 'FaIconDragAndDrop',
    computed: {
        isLargeScreen() {
            return isLargeScreen();
        }
    },
    data() {
        return {
            faIconDragAndDropClassName,
        }
    }
}
</script>